import logo_eparts_explorer from "../../../assets/images/logo-eparts.svg";
import logo_kt from "../../../../assets/images/logo-kt.svg";
import logoVandewiele from "../../../assets/images/logo-vandewiele-group.svg";

import { Link } from "@mui/material";
import {
  Copyright,
  Credits,
  GroupLogo,
  Root,
  Divisory,
  FooterContainer,
} from "./AppFooter.styles";

const AppFooter = () => {
  return (
    <Root>
      <FooterContainer>
        <GroupLogo src={logoVandewiele} alt="Vandewiele Group Logo"></GroupLogo>
        <Copyright>© Vandewiele NV {new Date().getFullYear()}</Copyright>
        <Credits style={{ width: 125, textAlign: "right" }}>
          <Link href="https://www.keytech.it/" target="_blank">
            <span>MADE BY</span>
            <img src={logo_kt} alt="" />
            <Divisory />
            <img src={logo_eparts_explorer} alt="" />
          </Link>
        </Credits>
      </FooterContainer>
    </Root>
  );
};

export default AppFooter;
